/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ExtraChargeType, MarkupBuilder} from 'compob2b-libs';
import {MarkupValueStrategy} from './markup-value.strategy';

export class IncreaseByValueStrategy extends MarkupValueStrategy implements MarkupBuilder {
  apply(price: number, value: number): number {
    return price + value;
  }

  getType(): ExtraChargeType {
    return ExtraChargeType.INCREASE_VALUE;
  }

}
